import React from 'react'
import PropTypes from 'prop-types'
import { Dialog } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'

import { onHandleFeatureHighlights } from 'app/auth/store/actions'
import FeatureHighlights from 'app/componentV4/FeatureHighlights/FeatureHighlights'

const DialogFeatureHighlights = () => {
  const dispatch = useDispatch()

  const { isOpen } = useSelector(({ auth }) => auth.featureHighlights)

  return (
    <Dialog
      open={isOpen}
      aria-labelledby="feature-highlights-dialog"
      aria-describedby="feature-highlights-dialog"
      maxWidth="md"
      PaperProps={{
        style: {
          borderRadius: 16,
          overflowY: 'unset',
        },
      }}
    >
      <FeatureHighlights
        onClose={() => dispatch(onHandleFeatureHighlights(false))}
      />
    </Dialog>
  )
}

DialogFeatureHighlights.propTypes = {
  onClose: PropTypes.func,
  isOnboard: PropTypes.bool,
}

export default DialogFeatureHighlights
